import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import CoverImagePanel, { importManagerId } from '../../components/CoverImagePanel';

const mapStateToProps = (state: StoreState) => {
	const {
		coverImagePanel: { driveItem, isDisplayed },
		importManager: { byId },
	} = state;

	return {
		driveItem,
		isDisplayed,
		isImportingFile: !!byId[importManagerId],
	};
};

export default connect(mapStateToProps)(CoverImagePanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverImagePanel/index.tsx